import { render, staticRenderFns } from "./error404.vue?vue&type=template&id=3d78ef4d&scoped=true&"
import script from "./error404.vue?vue&type=script&lang=js&"
export * from "./error404.vue?vue&type=script&lang=js&"
import style0 from "./error404.vue?vue&type=style&index=0&id=3d78ef4d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d78ef4d",
  null
  
)

export default component.exports